import React from "react";
import CustomSelect from "../common/Select";

const opcionesEstadoCivil = [
  { value: "soltero", label: "SOLTERO" },
  { value: "casado", label: "CASADO" },
  { value: "separado", label: "SEPARADO" },
  { value: "viudo", label: "VIUDO" },
  { value: "union_libre", label: "UNIÓN LIBRE" },
  { value: "otro", label: "OTRO" }
];

function SelectorEstadoCivil({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesEstadoCivil}
      value={value}
      onChange={onChange}
      placeholder="Estado Civil "
      label="Estado civil"
      error={error}
      required={required}
    />
  );
}

export default SelectorEstadoCivil;